export default {
	InvitationCode: "Code d'Invitation",
	CreditScore: "Score de Crédit",
	MyFinancial: {
		title: "Mes Finances",
		menu: ["Dépôt", "Retrait", "Transaction"]
	},
	MyDetail: {
		title: "Mon Détail",
		menu: ["Informations Personnelles", "Méthodes de Paiement"]
	},
	Other: {
		title: "Autre",
		menu: ["Nous Contacter", "Notifications", "Changer de Langue"]
	},
	Amount: ["Solde du Portefeuille", "Solde Gelé", "Revenus d'Aujourd'hui"],
	Logout: {
		title: "Se Déconnecter",
		content: "Êtes-vous sûr de vouloir vous déconnecter?"
	}
};
